var map = {
	"./basic-modal.vue": 4864,
	"./cart-additional-product.vue": 4349,
	"./cart-page.vue": 2825,
	"./cart-preview.vue": 2236,
	"./collection-filter-item.vue": 1865,
	"./collection-filter.vue": 1861,
	"./collection-filters.vue": 1259,
	"./collection-pagination.vue": 6888,
	"./collection-preview-product.vue": 334,
	"./collection-preview.vue": 9792,
	"./collection-product-swatch.vue": 8640,
	"./collection-product-swatches.vue": 8807,
	"./collection-product.vue": 8962,
	"./collection-products.vue": 7840,
	"./collection-selected-tags.vue": 2164,
	"./collection.vue": 711,
	"./config.vue": 709,
	"./expandable.vue": 1951,
	"./image-swiper.vue": 3154,
	"./img-yay.vue": 1540,
	"./map-box.vue": 1444,
	"./navbar-search.vue": 4655,
	"./newsletter-popup.vue": 8813,
	"./product-add-to-cart.vue": 8415,
	"./product-addon-blue-blocker.vue": 6746,
	"./product-addon-clip.vue": 679,
	"./product-addon-lens.vue": 9023,
	"./product-addon-monogram.vue": 6778,
	"./product-addons.vue": 4147,
	"./product-detail-size.vue": 6097,
	"./product-detail.vue": 261,
	"./product-details.vue": 3344,
	"./product-images.vue": 9134,
	"./product-model-photos.vue": 7144,
	"./product-price.vue": 9448,
	"./product-related-products.vue": 641,
	"./product-variant-selector.vue": 954,
	"./product-variant.vue": 7828,
	"./product-variants.vue": 9860,
	"./product.vue": 6571,
	"./renderless/addresses.vue": 2054,
	"./renderless/index.vue": 2645,
	"./renderless/navbar.vue": 9501,
	"./renderless/template-switch.vue": 7922,
	"./search-box-input.vue": 1485,
	"./search-box-results.vue": 8918,
	"./search-box.vue": 2416,
	"./sidebar-link.vue": 100,
	"./sidebar.vue": 6905,
	"./svg-care.vue": 9131,
	"./svg-face.vue": 6988,
	"./svg-materials.vue": 4552,
	"./svg-search.vue": 9527,
	"./svg-wave-animated.vue": 6092,
	"./svg-x.vue": 7777,
	"./tab.vue": 3125,
	"./tabs.vue": 4442,
	"./video-player.vue": 1751,
	"./view-on-map.vue": 9582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1904;